import { LoadingButton } from '@mui/lab';
import { Alert, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import { InvitationDecisions } from './useInvitationDecisions';

/** Accept and reject with the shared busy and error handling. */
export default function InvitationActions({
  decisions,
}: {
  decisions: InvitationDecisions;
}): JSX.Element {
  const { t } = useTranslation();
  const busy = Boolean(decisions.action);
  return (
    <Stack gap={1.5}>
      {decisions.error && (
        <Alert severity="error">{t('invitationAcceptance.actionError')}</Alert>
      )}
      <Stack direction={{ xs: 'column', md: 'row-reverse' }} gap={1}>
        <LoadingButton
          variant="contained"
          size="large"
          loading={decisions.action === 'accept'}
          disabled={busy}
          endIcon={<Iconify icon="solar:arrow-right-linear" />}
          onClick={() => void decisions.decide('accept')}
          sx={{ flex: { md: 1 } }}
        >
          {t('invitationAcceptance.accept')}
        </LoadingButton>
        <LoadingButton
          variant="outlined"
          color="inherit"
          size="large"
          loading={decisions.action === 'reject'}
          disabled={busy}
          onClick={() => void decisions.decide('reject')}
        >
          {t('invitationAcceptance.reject')}
        </LoadingButton>
      </Stack>
    </Stack>
  );
}
